//
// Lazyload
//
import { lazyLoadImages, lazyLoadVideos } from './functions.js';

document.addEventListener('DOMContentLoaded', function () {
	lazyLoadImages();
});

window.addEventListener('load', function () {
	lazyLoadVideos();
});
